export const bankAccountErrorTypes = {
  IBAN: 'IBAN',
  UK: 'UK',
}
